import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';

export const themeV2 = {
  colors: {
    inmarketGreen: unifiedPlatformColorPalette.inmarketGreen,
    beaconGreen: '#84D828',
    metricBlue: '#121E33',
    commandBlue: '#243E66',
    magnetBlue: '#4591C7',
    leadBlue: '#AED7F4',
    frameworkGray: '#F5F6F8',
    lightGray: '#E8E8E8',
    lightBlue: '#AED7F3',
    white: unifiedPlatformColorPalette.white,
    red: '#C00000',
  },
  charSpacing: {
    tight: -1.5,
    loose: 3,
    veryLoose: 6,
  },
} as const;
